import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { GetAction } from '../../Component/GetAction'
import ManageTable from '../ManageTable'
import { RequireModule, PageHeader, downloadCsv } from './shared'

function UserReportsPage() {
  const [rows, setRows] = useState([])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      setLoading(true)
      const data = await GetAction('get', {}, 'user/userList')
      if (cancelled) return
      if (data?.status === 'success' && Array.isArray(data.response)) {
        setRows(data.response)
        setError('')
      } else {
        setError(data?.message || 'Failed to load user report.')
        setRows([])
      }
      setLoading(false)
    })()
    return () => {
      cancelled = true
    }
  }, [])

  const columns = [
    { key: 'index', label: '#', width: '60px' },
    {
      key: 'name',
      label: 'Name',
      render: (row) =>
        row.id ? (
          <Link
            className="manage-name-link"
            to={{
              pathname: `/manage/user-reports/${row.id}`,
              state: { user: row },
            }}
            title="View ledger"
          >
            {row.name || '—'}
          </Link>
        ) : (
          row.name || '—'
        ),
    },
    { key: 'mobile', label: 'Mobile' },
    { key: 'city', label: 'City' },
    {
      key: 'created_at',
      label: 'Date',
      render: (row) => row.created_at || '—',
    },
    {
      key: 'role_name',
      label: 'Role',
      render: (row) => row.role_name || '—',
    },
  ]

  const exportRows = () => {
    downloadCsv(
      'user-reports.csv',
      [
        { key: 'index', label: '#' },
        { key: 'name', label: 'Name' },
        { key: 'mobile', label: 'Mobile' },
        { key: 'city', label: 'City' },
        { key: 'created_at', label: 'Date' },
        { key: 'role_name', label: 'Role' },
      ],
      rows
    )
  }

  return (
    <RequireModule moduleKey="user_reports">
      <PageHeader
        title="User Reports"
        subtitle="Click a member name to open their donation ledger."
        actions={
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={exportRows}
            disabled={!rows.length}
          >
            Export CSV
          </button>
        }
      />
      {error ? <div className="manage-alert manage-alert-err">{error}</div> : null}
      <div className="manage-card">
        {loading ? (
          <div className="text-center py-4">
            <div className="spinner-border text-warning" role="status" />
          </div>
        ) : (
          <ManageTable
            columns={columns}
            rows={rows}
            searchKeys={['name', 'mobile', 'city', 'role_name']}
          />
        )}
      </div>
    </RequireModule>
  )
}

export default UserReportsPage
